{
  "countries": {
    "AF": "Afghanistan",
    "AX": "Îles Åland",
    "AL": "Albanie",
    "DZ": "Algérie",
    "AS": "Samoa américaines",
    "AD": "Andorre",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarctique",
    "AG": "Antigua-et-Barbuda",
    "AR": "Argentine",
    "AM": "Arménie",
    "AW": "Aruba",
    "AC": "Île de l’Ascension",
    "AU": "Australie",
    "AT": "Autriche",
    "AZ": "Azerbaïdjan",
    "BS": "Bahamas",
    "BH": "Bahreïn",
    "BD": "Bangladesh",
    "BB": "Barbade",
    "BY": "Biélorussie",
    "BE": "Belgique",
    "BZ": "Belize",
    "BJ": "Bénin",
    "BM": "Bermudes",
    "BT": "Bhoutan",
    "BO": "Bolivie",
    "BA": "Bosnie-Herzégovine",
    "BW": "Botswana",
    "BR": "Brésil",
    "IO": "Territoire britannique de l’océan Indien",
    "VG": "Îles Vierges britanniques",
    "BN": "Brunéi",
    "BG": "Bulgarie",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodge",
    "CM": "Cameroun",
    "CA": "Canada",
    "IC": "Îles Canaries",
    "CV": "Cap-Vert",
    "BQ": "Pays-Bas caribéens",
    "KY": "Îles Caïmans",
    "CF": "République centrafricaine",
    "EA": "Ceuta et Melilla",
    "TD": "Tchad",
    "CL": "Chili",
    "CN": "Chine",
    "CX": "Île Christmas",
    "CC": "Îles Cocos",
    "CO": "Colombie",
    "KM": "Comores",
    "CG": "Congo-Brazzaville",
    "CD": "Congo-Kinshasa",
    "CK": "Îles Cook",
    "CR": "Costa Rica",
    "CI": "Côte d’Ivoire",
    "HR": "Croatie",
    "CU": "Cuba",
    "CW": "Curaçao",
    "CY": "Chypre",
    "CZ": "Tchéquie",
    "DK": "Danemark",
    "DG": "Diego Garcia",
    "DJ": "Djibouti",
    "DM": "Dominique",
    "DO": "République dominicaine",
    "EC": "Équateur",
    "EG": "Égypte",
    "SV": "Salvador",
    "GQ": "Guinée équatoriale",
    "ER": "Érythrée",
    "EE": "Estonie",
    "SZ": "Eswatini",
    "ET": "Éthiopie",
    "FK": "Îles Malouines",
    "FO": "Îles Féroé",
    "FJ": "Fidji",
    "FI": "Finlande",
    "FR": "France",
    "GF": "Guyane française",
    "PF": "Polynésie française",
    "TF": "Terres australes françaises",
    "GA": "Gabon",
    "GM": "Gambie",
    "GE": "Géorgie",
    "DE": "Allemagne",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Grèce",
    "GL": "Groenland",
    "GD": "Grenade",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernesey",
    "GN": "Guinée",
    "GW": "Guinée-Bissau",
    "GY": "Guyana",
    "HT": "Haïti",
    "HN": "Honduras",
    "HK": "R.A.S. chinoise de Hong Kong",
    "HU": "Hongrie",
    "IS": "Islande",
    "IN": "Inde",
    "ID": "Indonésie",
    "IR": "Iran",
    "IQ": "Irak",
    "IE": "Irlande",
    "IM": "Île de Man",
    "IL": "Israël",
    "IT": "Italie",
    "JM": "Jamaïque",
    "JP": "Japon",
    "JE": "Jersey",
    "JO": "Jordanie",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "XK": "Kosovo",
    "KW": "Koweït",
    "KG": "Kirghizistan",
    "LA": "Laos",
    "LV": "Lettonie",
    "LB": "Liban",
    "LS": "Lesotho",
    "LR": "Libéria",
    "LY": "Libye",
    "LI": "Liechtenstein",
    "LT": "Lituanie",
    "LU": "Luxembourg",
    "MO": "R.A.S. chinoise de Macao",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaisie",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malte",
    "MH": "Îles Marshall",
    "MQ": "Martinique",
    "MR": "Mauritanie",
    "MU": "Maurice",
    "YT": "Mayotte",
    "MX": "Mexique",
    "FM": "États fédérés de Micronésie",
    "MD": "Moldavie",
    "MC": "Monaco",
    "MN": "Mongolie",
    "ME": "Monténégro",
    "MS": "Montserrat",
    "MA": "Maroc",
    "MZ": "Mozambique",
    "MM": "Myanmar (Birmanie)",
    "NA": "Namibie",
    "NR": "Nauru",
    "NP": "Népal",
    "NL": "Pays-Bas",
    "NC": "Nouvelle-Calédonie",
    "NZ": "Nouvelle-Zélande",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigéria",
    "NU": "Niue",
    "NF": "Île Norfolk",
    "KP": "Corée du Nord",
    "MK": "Macédoine du Nord",
    "MP": "Îles Mariannes du Nord",
    "NO": "Norvège",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palaos",
    "PS": "Territoires palestiniens",
    "PA": "Panama",
    "PG": "Papouasie-Nouvelle-Guinée",
    "PY": "Paraguay",
    "PE": "Pérou",
    "PH": "Philippines",
    "PN": "Îles Pitcairn",
    "PL": "Pologne",
    "PT": "Portugal",
    "XA": "Pseudo-Accents",
    "XB": "Pseudo-Bidi",
    "PR": "Porto Rico",
    "QA": "Qatar",
    "RE": "La Réunion",
    "RO": "Roumanie",
    "RU": "Russie",
    "RW": "Rwanda",
    "WS": "Samoa",
    "SM": "Saint-Marin",
    "ST": "Sao Tomé-et-Principe",
    "SA": "Arabie saoudite",
    "SN": "Sénégal",
    "RS": "Serbie",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapour",
    "SX": "Saint-Martin (partie néerlandaise)",
    "SK": "Slovaquie",
    "SI": "Slovénie",
    "SB": "Îles Salomon",
    "SO": "Somalie",
    "ZA": "Afrique du Sud",
    "GS": "Géorgie du Sud-et-les Îles Sandwich du Sud",
    "KR": "Corée du Sud",
    "SS": "Soudan du Sud",
    "ES": "Espagne",
    "LK": "Sri Lanka",
    "BL": "Saint-Barthélemy",
    "SH": "Sainte-Hélène",
    "KN": "Saint-Kitts-et-Nevis",
    "LC": "Sainte-Lucie",
    "MF": "Saint-Martin",
    "PM": "Saint-Pierre-et-Miquelon",
    "VC": "Saint-Vincent-et-les-Grenadines",
    "SD": "Soudan",
    "SR": "Suriname",
    "SJ": "Svalbard et Jan Mayen",
    "SE": "Suède",
    "CH": "Suisse",
    "SY": "Syrie",
    "TW": "Taïwan",
    "TJ": "Tadjikistan",
    "TZ": "Tanzanie",
    "TH": "Thaïlande",
    "TL": "Timor oriental",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinité-et-Tobago",
    "TA": "Tristan da Cunha",
    "TN": "Tunisie",
    "TR": "Turquie",
    "TM": "Turkménistan",
    "TC": "Îles Turques-et-Caïques",
    "TV": "Tuvalu",
    "UG": "Ouganda",
    "UA": "Ukraine",
    "AE": "Émirats arabes unis",
    "GB": "Royaume-Uni",
    "US": "États-Unis",
    "UY": "Uruguay",
    "UM": "Îles mineures éloignées des États-Unis",
    "VI": "Îles Vierges des États-Unis",
    "UZ": "Ouzbékistan",
    "VU": "Vanuatu",
    "VA": "État de la Cité du Vatican",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "WF": "Wallis-et-Futuna",
    "EH": "Sahara occidental",
    "YE": "Yémen",
    "ZM": "Zambie",
    "ZW": "Zimbabwe"
  }
}
